import React from 'react'
import { observer } from 'mobx-react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import close from 'assets/images/close-round.png'
import { Application } from 'services'
import { NotifyType } from "../../store/NotifyStore";

const useStyles = makeStyles(({ palette }) =>
    createStyles({
        root: {
            backgroundColor: 'rgba(235, 235, 235, 0.1)',
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '18px',
            color: palette.common.white,
            height: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            zIndex: 9999,
        },
        link: {
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '18px',
            color: '#75B952',
            textDecorationLine: 'underline',
            marginLeft: '10px',
            cursor: 'pointer',
        },
        center: {},
        end: {
            position: 'absolute',
            top: '4px',
            right: '5px',
            cursor: 'pointer',
        },
        linkWhite: {
            color: '#FFFFFF',
        },
        backgroundGreen: {
            backgroundColor: '#75B952',
        },
    }),
)

const Notify = observer(() => {
    const classes = useStyles()

    const app = Application.instance()
    const { NotifyStore } = app.store

    const handleResend = () => {
        const username = NotifyStore.username
        app.auth
            .resendSignUp(username)
            .then(data => {
                handleClose()
            })
            .catch(e => {
                console.error(e)
            })
    }
    const handleLogin = () => {
        app.event.$emit('overlay.activity.login', {
            status: true,
        })
        NotifyStore.hide()
    }

    const handleClose = () => NotifyStore.hide()

    const notifyConfig = {
        [NotifyType.RESEND]: {
            divStyle: '',
            message: 'Please confirm your email. Didn\'t receive an email?',
            linkTitle: 'Resend',
            linkStyle: '',
            linkAction: () => handleResend(),
        },
        [NotifyType.CONFIRM_SUCCESS]: {
            divStyle: classes.backgroundGreen,
            message: 'Email has been successfully confirmed',
            linkTitle: 'Login',
            linkStyle: classes.linkWhite,
            linkAction: () => handleLogin(),
        },
        [NotifyType.CONFIRM_FAIL]: {
            divStyle: '',
            message: 'Link has been expired. Please resend confirmation link and try again',
            linkTitle: 'Resend',
            linkStyle: '',
            linkAction: () => handleResend(),
        }
    }

    if (NotifyStore.type === undefined){
        return null
    }
    const config = notifyConfig[NotifyStore.type]
    return (
        <>
            <div className={`${classes.root} ${config.divStyle}`}>
                <div className={classes.center}>
                    <div>{config.message}</div>
                </div>
                <div className={`${classes.link} ${config.linkStyle}`} onClick={config.linkAction}>
                    {config.linkTitle}
                </div>

                <div className={classes.end}>
                    <img src={close} onClick={handleClose} alt="close" />
                </div>
            </div>
        </>
    )
})

export default Notify
